import {
  ChangeToApprove,
  ETenantSettingActionType
} from './tenant-setting-change';

export class UpdateTenantSettingChangeToApprove extends ChangeToApprove {
  constructor(public message: string) {
    super(-1, ETenantSettingActionType.UpdateTenantSettings, message);
  }
}
